import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function SendGridNode({ id, data, selected }) {
  const toLine = data.to ? `→ ${data.to}` : null;
  const modeLine = data.contentType === 'template'
    ? (data.templateId ? `Template: ${data.templateId}` : 'Template: (not set)')
    : null;
  const summary = [toLine, modeLine].filter(Boolean).join(' · ');

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.integrations}
      image={data.image || '/images/sendgridicon.png'}
      label={data.label}
    >
      <p className="text-xs text-gray-500 truncate">{summary || data.description}</p>
    </BaseNode>
  );
}
